import styled from 'styled-components';

import { getFontStyle } from '~components/Text/helper';

export const Wrapper = styled.section`
  max-width: 794px;
  box-sizing: border-box;
  border: 1px solid #ebebeb;
  border-radius: 4px;
  scroll-margin-top: 130px;
  background-color: ${({ theme }) => theme.colors.white100};

  ${({ theme }) => theme.media.with('mobile', 'tablet')} {
    width: 100%;
    max-width: none;
  }

  ${({ theme }) => theme.media.mobile} {
    position: relative;
    border-width: 0;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 32px 32px 0 32px;

  ${({ theme }) => theme.media.mobile} {
    padding: 30px 20px 0 20px;
  }
`;

export const CardConent = styled.div`
  padding: 0 32px 32px 32px;

  ${({ theme }) => theme.media.mobile} {
    padding: 0 20px 30px 20px;
  }
`;

export const BadgeNew = styled.div`
  position: absolute;
  top: 0;
  right: -22px;
  color: ${({ theme }) => theme.colors.magenta500};
  ${getFontStyle('midium120_C2')}
`;
